import styled, { css } from 'styled-components';
import { fpx } from '../../../../styles/fluid';

export const ScPromoCodeRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${fpx(8)};
  width: 100%;
`;

export const ScPromoCodeField = styled.div`
  display: flex;
  flex: 1 0 0;
  align-items: center;
  min-width: 0;
  height: ${fpx(46)};
  padding: ${fpx(8)} ${fpx(8)} ${fpx(8)} ${fpx(12)};
  border: 1px dashed #ff7226;
  border-radius: ${fpx(12)};
  background: rgba(0, 0, 0, 0.9);
  color: #fff;
  font-size: ${fpx(20)};
  font-weight: 700;
  line-height: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (orientation: portrait) {
    height: ${fpx(42)};
    padding-left: ${fpx(8)};
    font-size: ${fpx(16)};
  }
`;

export const ScCopyButton = styled.button<{ $isCopied: boolean }>`
  position: relative;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: ${fpx(46)};
  height: ${fpx(46)};
  border: 0;
  border-radius: ${fpx(12)};
  background: #2c2f31;
  cursor: pointer;
  transition: opacity 0.2s ease;

  img {
    display: block;
    width: ${fpx(20)};
    height: ${fpx(20)};
  }

  &::after {
    content: attr(data-copied);
    position: absolute;
    bottom: calc(100% + ${fpx(6)});
    left: 50%;
    padding: ${fpx(4)} ${fpx(8)};
    border-radius: ${fpx(6)};
    background: #2c2f31;
    color: #fff;
    font-size: ${fpx(12)};
    font-weight: 500;
    white-space: nowrap;
    opacity: 0;
    transform: translateX(-50%);
    transition: opacity 0.2s ease;
    pointer-events: none;
  }

  ${({ $isCopied }) =>
    $isCopied &&
    css`
      &::after {
        opacity: 1;
      }
    `}

  @media (hover: hover) {
    &:hover {
      opacity: 0.8;
    }
  }

  @media (orientation: portrait) {
    width: ${fpx(42)};
    height: ${fpx(42)};
  }
`;
